<div class="block--content m-0 block min-h-full">
    <div class="mx-auto max-w-screen-xl md:px-20">
        <rwidget-alert></rwidget-alert>
        <div class="vl-app-light:mb-4 vl-app-light:drop-shadow bg-white md:invisible">
            <div class="flex h-16 flex-row items-center justify-between">
                <button
                    class="flex w-16 items-center justify-center p-4"
                    [attr.aria-label]="'LOCAL_BTN_BACK' | translate"
                    [class.invisible]="hideBackButton"
                    (click)="handleBackClicked()"
                    mat-icon-button>
                    <mat-icon class="material-icons-outlined text-2xl dark:filter-yellow"> arrow_back </mat-icon>
                </button>
                <h1 class="text-base font-bold">
                    {{ 'TRAFFIC_DISRUPTION_TITLE' | translate }}
                </h1>
                <div class="w-16" *ngIf="!env.SHOW_DISRUPTION_LIST_NOTIFICATION_BUTTONS"></div>
                <button
                    class="flex w-16 items-center justify-center p-4"
                    *ngIf="env.SHOW_DISRUPTION_LIST_NOTIFICATION_BUTTONS"
                    [attr.aria-label]="'DISRUPTION_LIST_SUBSCRIBE_NOTIFICATIONS_BUTTON' | translate"
                    (click)="onNotificationClick($event)"
                    mat-icon-button>
                    <mat-icon class="material-icons-outlined text-2xl dark:filter-yellow">notifications</mat-icon>
                </button>
            </div>
        </div>
        <div class="hidden md:block">
            <h1 class="text-3xl font-semibold">{{ 'TRAFFIC_DISRUPTION_TITLE' | translate }}</h1>
            <div class="pb-14 pt-6">
                <p class="leading-5">{{ 'TRAFFIC_DISRUPTION_DESCRIPTION' | translate }}</p>
            </div>
        </div>
        <div
            class="flex w-full flex-col gap-2 dark:bg-contrast-black md:flex-row md:items-start"
            [ngClass]="{ 'mb-2 sm:mb-12': env.SHOW_DISRUPTION_LIST_NOTIFICATION_BUTTONS }">
            <div
                class="md:min-w-96 w-full rounded-md bg-white shadow-sm md:w-96 md:shrink-0"
                *ngIf="env.SHOW_DISRUPTION_LIST_NOTIFICATION_BUTTONS">
                <div
                    class="flex flex-col items-center justify-center gap-2 p-4"
                    *ngIf="env.SHOW_DISRUPTION_LIST_NOTIFICATION_BUTTONS">
                    <ion-button
                        class="w-full dark:border-contrast-yellow"
                        [ngClass]="(isLoggedIn$ | async) ? 'logged-in' : 'logged-out'"
                        [attr.aria-label]="'DISRUPTION_LIST_SUBSCRIBE_NOTIFICATIONS_BUTTON' | translate"
                        (click)="onNotificationClick($event)"
                        size="large"
                        color="secondary">
                        <ion-label class="whitespace-normal text-sm font-bold normal-case">
                            {{ 'DISRUPTION_LIST_SUBSCRIBE_NOTIFICATIONS_BUTTON' | translate }}
                        </ion-label>
                    </ion-button>
                    <rwidget-add-email-modal #emailModal (completed)="onEmailModalCompleted($event)">
                    </rwidget-add-email-modal>
                    <ion-button
                        class="w-full dark:border-contrast-yellow"
                        *ngIf="isLoggedIn$ | async"
                        [attr.aria-label]="'DISRUPTION_LIST_MANAGE_NOTIFICATIONS_BUTTON' | translate"
                        [routerLink]="'/account/notification-settings' | localize"
                        size="large"
                        color="secondary">
                        <ion-label class="whitespace-normal text-sm font-bold normal-case">
                            {{ 'DISRUPTION_LIST_MANAGE_NOTIFICATIONS_BUTTON' | translate }}
                        </ion-label>
                    </ion-button>
                </div>
                <ion-accordion-group
                    class="vl-app-light-dark:mb-0 dark:border-contrast-yellow dark:bg-contrast-black"
                    *ngIf="!this.env.DISRUPTION_MESSAGES?.HIDE_SYSTEM_STATUS"
                    [ngStyle]="{ 'pointer-events': isDesktopView ? 'none' : 'auto' }"
                    [value]="isCollapsedSummary"
                    (ionChange)="accordionSummaryClicked($event)">
                    <ion-accordion value="summary">
                        <ion-item
                            class="accordions"
                            [ngClass]="{
                                'accordion-grey': isDesktopView
                            }"
                            slot="header">
                            <div class="flex w-full items-center justify-between px-4">
                                <h5
                                    class="hu-light-dark:font-bold pr-2 text-xs font-semibold uppercase leading-4 tracking-wide text-grey-dark dark:text-contrast-yellow"
                                    [class.normal-case]="env.REMOVE_UPPERCASE">
                                    {{ 'SYSTEM_STATUS' | translate }}
                                </h5>
                                <span
                                    class="inline-block text-xs font-semibold text-[var(--color-secondary)] dark:text-contrast-yellow md:hidden"
                                    slot="end"
                                    >{{ (showAccordionSummary ? 'HIDE' : 'SHOW') | translate }}</span
                                >
                            </div>
                        </ion-item>
                        <div class="px-4 pb-4" slot="content">
                            <rwidget-disruption-messages-summary
                                class="lg:w-[22rem]"
                                [messagesSummary]="messagesSummary"
                                [packageVersion]="
                                    messagesPackage?.packageVersion
                                "></rwidget-disruption-messages-summary>
                        </div>
                    </ion-accordion>
                </ion-accordion-group>

                <ion-accordion-group
                    *ngIf="env.DISRUPTION_MESSAGES?.ENABLE_FILTERS && countActiveAlert !== 0"
                    [value]="isCollapsedFilters"
                    (ionChange)="accordionFiltersClicked($event)">
                    <ion-accordion [ngClass]="{ 'mb-4 drop-shadow': !showAccordionFilters }" value="filters">
                        <ion-item
                            class="accordions w-full dark:bg-contrast-black"
                            [ngClass]="{ 'sr-app-light-dark:drop-shadow-none drop-shadow': showAccordionFilters }"
                            slot="header">
                            <div
                                class="flex w-full items-center justify-between px-4 dark:bg-contrast-black"
                                [ngClass]="{ 'sr-app-light-dark:bg-grey-white_smoke ': showAccordionFilters }">
                                <h5
                                    class="pr-2 text-xs font-semibold uppercase leading-4 tracking-wide text-grey-dark dark:text-contrast-yellow"
                                    [class.normal-case]="env.REMOVE_UPPERCASE">
                                    {{ 'FILTER_ALERTS' | translate }}
                                </h5>

                                <span
                                    class="text-xs font-semibold text-[var(--color-secondary)] dark:text-contrast-yellow"
                                    >{{ (showAccordionFilters ? 'HIDE' : 'SHOW') | translate }}</span
                                >
                            </div>
                        </ion-item>
                        <div class="bg-grey-white_smoke p-4 dark:bg-contrast-black" slot="content">
                            <ion-item
                                class="solid-border mb-4 w-full rounded-lg border border-gray-100 shadow dark:border-contrast-yellow"
                                *ngIf="customFilters?.includes(DisruptionFilters.CATEGORY) ?? true"
                                (click)="openModal(disruptionMessagesModalType.CATEGORY)"
                                lines="none"
                                fill="clear">
                                <ion-label class="text-base font-normal normal-case leading-5" role="button">{{
                                    !chosenCategories?.length
                                        ? ('DISRUPTION_FILTER_ALL_CATEGORIES' | translate)
                                        : getCategoriesTranslation()
                                }}</ion-label>
                                <ion-icon
                                    class="vl-app-light:text-grey-zambezy dark:filter-yellow"
                                    [name]="arrowIcon"
                                    aria-hidden="true"
                                    title="{{ 'CHEVRON_DOWN' | translate }}"
                                    aria-label="{{ 'CHEVRON_DOWN' | translate }}"
                                    size="small"></ion-icon>
                            </ion-item>
                            <ion-item
                                class="dropdown-height mb-4 w-full items-center rounded-lg border border-gray-100 shadow dark:border-contrast-yellow"
                                *ngIf="customFilters?.includes(DisruptionFilters.ROUTE) ?? true"
                                (click)="openModal(disruptionMessagesModalType.ROUTE)"
                                lines="none"
                                fill="clear">
                                <ion-label
                                    class="text-base font-normal normal-case leading-5"
                                    [attr.aria-label]="
                                        !chosenRoutes?.length
                                            ? ('DISRUPTION_FILTER_ALL_LINES' | translate)
                                            : ('DISRUPTION_FILTER_LINES' | translate) + chosenRoutes.join(', ')
                                    "
                                    role="button"
                                    >{{
                                        !chosenRoutes?.length
                                            ? ('ALL_LINES' | translate)
                                            : ('LINES' | translate) + chosenRoutes.join(', ')
                                    }}</ion-label
                                >
                                <ion-icon
                                    class="vl-app-light:text-grey-zambezy dark:filter-yellow"
                                    [name]="arrowIcon"
                                    aria-hidden="true"
                                    title="{{ 'CHEVRON_DOWN' | translate }}"
                                    aria-label="{{ 'CHEVRON_DOWN' | translate }}"
                                    size="small"></ion-icon>
                            </ion-item>
                            <ion-item
                                class="mb-4 w-full rounded-lg border border-gray-100 shadow"
                                *ngIf="
                                    customFilters?.includes(DisruptionFilters.DIRECTION) &&
                                    directions.length &&
                                    chosenRoutes.length === 1
                                "
                                (click)="openModal(disruptionMessagesModalType.DIRECTION)"
                                lines="none"
                                fill="clear">
                                <ion-label class="text-base font-normal normal-case leading-5" role="button">{{
                                    !chosenDirections?.length
                                        ? ('DISRUPTION_FILTER_ALL_DIRECTION' | translate)
                                        : ('DIRECTION' | translate) + chosenDirections.join(', ')
                                }}</ion-label>
                                <ion-icon
                                    class="vl-app-light:text-grey-zambezy"
                                    [name]="arrowIcon"
                                    aria-hidden="true"
                                    title="{{ 'CHEVRON_DOWN' | translate }}"
                                    aria-label="{{ 'CHEVRON_DOWN' | translate }}"
                                    size="small">
                                </ion-icon>
                            </ion-item>
                            <div
                                class="flex w-full items-center justify-between"
                                *ngIf="customFilters?.includes(DisruptionFilters.UPCOMING) ?? true">
                                <ion-label class="text-base font-normal normal-case leading-5">{{
                                    'UPCOMING_ALERTS' | translate
                                }}</ion-label>
                                <ion-toggle
                                    class="all-routes-toggle"
                                    [checked]="upcomingAlerts"
                                    (ionChange)="upcomingAlertsToggle($event)"
                                    mode="ios"></ion-toggle>
                            </div>
                            <div
                                class="flex h-10 w-full items-center justify-between"
                                *ngIf="customFilters?.includes(DisruptionFilters.DATE)">
                                <ion-label
                                    class="text-base font-normal normal-case leading-4 dark:text-contrast-yellow"
                                    >{{ 'LOCAL_LABEL_DATE' | translate }}</ion-label
                                >
                                <ion-label
                                    class="text-base font-bold normal-case leading-4 dark:text-contrast-yellow"
                                    *ngIf="date">
                                    {{ dateValue.datetime | date: env.PRIMARY_DATE_FORMAT_NGPIPE }}</ion-label
                                >

                                <ion-button
                                    class="m-0 p-0 text-secondary dark:text-contrast-yellow"
                                    id="date"
                                    [attr.aria-label]="'DISRUPTION_FILTER_DATE_PICKER_CALENDAR' | translate"
                                    color="secondary"
                                    fill="clear">
                                    <ng-container *ngIf="env.APP_NAME === 'vastmanland-app'; else matIconTemplate">
                                        <ion-icon
                                            class="text-2xl dark:filter-yellow"
                                            src="{{ assetsPath$ | async }}/img/disruption-messages/calender.svg"
                                            aria-hidden="true">
                                        </ion-icon>
                                    </ng-container>
                                    <ng-template #matIconTemplate>
                                        <mat-icon aria-hidden="true">date_range</mat-icon>
                                    </ng-template>
                                </ion-button>
                            </div>
                        </div>
                    </ion-accordion>
                </ion-accordion-group>
            </div>
            <rwidget-disruption-messages-accordion
                class="block w-full min-w-0 px-2 md:flex-1 md:basis-0 md:px-0"
                *ngIf="messages.length > 0; else emptyState"
                [messages]="messages">
            </rwidget-disruption-messages-accordion>
            <ng-template #emptyState>
                <p class="flex w-full justify-center bg-white p-4">{{ 'EMPTY_STATE_TRAFFIC' | translate }}</p>
            </ng-template>
        </div>
    </div>
</div>
<ridango-ui-datetime-select
    *ngIf="showDatePicker"
    [(ngModel)]="dateValue"
    [triggerId]="'date'"
    [maxDate]="maxDate"
    [resetFilter]="resetFilter"
    (ngModelChange)="changeDate()"
    minDate="2000-01-01"
    dateOnly="true"></ridango-ui-datetime-select>
